export default __webpack_public_path__ + "static/media/05.45d9ec79.jpg";